import { FullClientConfig, Stage } from '../types';

const howserServiceConfig: FullClientConfig['howserService'] = {
  [Stage.DEV]: {
    endpoint: 'https://demo.personalize-gamma.us-west-2.amazonaws.com',
    cwRUMAppMonitorId: '2372e04d-e928-4d9a-bfcb-45cce0db3886',
    cwRUMIdentityPoolId: 'us-east-1:ea2215a1-4cc5-4aa9-86e9-79bc887b696d',
    serviceAccount: '275934361642',
    enableAdobeAnalytics: false,
  },
  [Stage.ALPHA]: {
    endpoint: 'https://demo.personalize-gamma.us-west-2.amazonaws.com',
    cwRUMAppMonitorId: '2372e04d-e928-4d9a-bfcb-45cce0db3886',
    cwRUMIdentityPoolId: 'us-east-1:ea2215a1-4cc5-4aa9-86e9-79bc887b696d',
    serviceAccount: '275934361642',
    enableAdobeAnalytics: true,
  },
  [Stage.BETA]: {
    endpoint: 'https://demo.personalize-gamma.us-west-2.amazonaws.com',
    cwRUMAppMonitorId: '3c6e571f-c79e-459f-a16e-1c9b35382a69',
    cwRUMIdentityPoolId: 'us-east-1:32b5c18f-394d-4e8e-b4bb-326da24cde53',
    serviceAccount: '834313952383',
    enableAdobeAnalytics: false,
  },
  [Stage.GAMMA]: {
    endpoint: 'https://demo.personalize-gamma.us-west-2.amazonaws.com',
    cwRUMAppMonitorId: 'a04594d6-76ba-4605-883f-1f78b987c081',
    cwRUMIdentityPoolId: 'us-east-1:241c7761-a10c-4c40-9bcd-7623a04df8f0',
    serviceAccount: '283105873320',
    enableAdobeAnalytics: false,
  },
  [Stage.PROD]: {
    endpoint: 'https://demo.personalize.us-east-1.amazonaws.com',
    cwRUMAppMonitorId: '765ba651-8b1c-4a2a-b359-bf5bd2333b1a',
    cwRUMIdentityPoolId: 'us-east-1:27caa100-4f21-4089-aa9c-c9968e75ca12',
    serviceAccount: '320936761996',
    enableAdobeAnalytics: true,
  },
};

export default howserServiceConfig;
